/**
 * Register the PWA service worker when running in production and in a supported browser.
 */
export function registerServiceWorker(): void {
    if (
        import.meta.env.PROD &&
        'serviceWorker' in navigator
    ) {
        window.addEventListener('load', () => {
            navigator.serviceWorker
                .register('/sw.js', { scope: '/' })
                .then((reg) => {
                    reg.addEventListener('updatefound', () => {
                        const newWorker = reg.installing;
                        if (!newWorker) return;
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                // New content available; optionally show "Update available" UI
                                console.log('PWA: New content available; refresh to update.');
                            }
                        });
                    });
                })
                .catch((err) => console.warn('PWA: Service worker registration failed', err));
        });
    }
}
